/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleCircleIcon20Solid = forwardRef('MoneyCurrencyRubleCircleIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9 7v2.5h2.15a1.25 1.25 0 1 0 0-2.5H9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-9 1h2.15a2.75 2.75 0 1 0 0-5.5H8.483a.983.983 0 0 0-.983.983V9.5H7A.75.75 0 0 0 7 11h.5v1H7a.75.75 0 0 0 0 1.5h.5v1a.75.75 0 0 0 1.5 0v-1h2.5a.75.75 0 0 0 0-1.5H9v-1Z" })));
});
